var render = function render(){
  var _vm$global$profile,
    _vm$global$profile2,
    _this = this,
    _vm$global$profile3,
    _vm$orgSkin,
    _vm$itemized,
    _vm$account,
    _vm$account2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "no-click-animation": "",
      "transition": "",
      "value": true
    }
  }, [_c('div', {
    staticClass: "grey lighten-4 fill-height d-flex flex-column"
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadSpreadsheetStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.loadContactsStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.createNextStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.copyAutomationStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteAutomationStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.loadPriceStatus
    }
  }), _c('sign-in-dialog', {
    ref: "sign-in",
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "file-upload",
    attrs: {
      "type": "file",
      "accept": ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    },
    on: {
      "change": _vm.loadSpreadsheet
    }
  }), _vm.showPreview ? _c('card-open', {
    attrs: {
      "preview": _vm.selectedRowPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }) : _vm._e(), _vm.showSelectDesigns ? _c('select-designs-dialog', {
    attrs: {
      "limit": 100
    },
    on: {
      "input": function ($event) {
        _vm.showSelectDesigns = false;
      }
    },
    model: {
      value: _vm.staged.design_ids,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "design_ids", $$v);
      },
      expression: "staged.design_ids"
    }
  }) : _vm._e(), _vm.showAddPaymentMethod ? _c('add-payment-method-dialog', {
    attrs: {
      "show-name": ""
    },
    on: {
      "complete": function ($event) {
        return _vm.$emit('update-account');
      }
    },
    model: {
      value: _vm.showAddPaymentMethod,
      callback: function ($$v) {
        _vm.showAddPaymentMethod = $$v;
      },
      expression: "showAddPaymentMethod"
    }
  }) : _vm._e(), _vm.showImportSpreadsheet ? _c('dialog-scroll-lock', {
    attrs: {
      "width": _vm.showSpreadsheetOptions.includes('Example template') ? 800 : 500
    },
    model: {
      value: _vm.showImportSpreadsheet,
      callback: function ($$v) {
        _vm.showImportSpreadsheet = $$v;
      },
      expression: "showImportSpreadsheet"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "z-index": "1",
      "top": "0",
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showImportSpreadsheet = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Import from spreadsheet")]), _c('v-card-subtitle', [_vm._v("csv, xls, xlsx")]), _c('title-toggle', {
    staticClass: "title-toggle-card",
    attrs: {
      "multiple": "",
      "title": "Import options",
      "color": "primary",
      "icon": _vm.mdiCog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Import options")])];
      },
      proxy: true
    }], null, false, 3153190578),
    model: {
      value: _vm.showSpreadsheetOptions,
      callback: function ($$v) {
        _vm.showSpreadsheetOptions = $$v;
      },
      expression: "showSpreadsheetOptions"
    }
  }, [_c('div', {
    staticClass: "px-6 text-body-2"
  }, [_vm.staged.order.type == 'GROUP' ? [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Include contributors column"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Include "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("contributors")]), _vm._v(" column")];
      },
      proxy: true
    }], null, false, 3153108036),
    model: {
      value: _vm.staged.import.contributors,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "contributors", $$v);
      },
      expression: "staged.import.contributors"
    }
  }), _c('div', {
    staticClass: "ml-8 mb-6 text--label-active"
  }, [_vm._v("A list of email addresses to invite to sign each card")])] : _vm._e(), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.org_id ? [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Include owner column"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Include "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("owner")]), _vm._v(" column")];
      },
      proxy: true
    }], null, false, 1964241829),
    model: {
      value: _vm.staged.import.owner,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "owner", $$v);
      },
      expression: "staged.import.owner"
    }
  }), _c('div', {
    staticClass: "ml-8 mb-6 text--label-active"
  }, [_vm._v("Delegate ownership to another email address in your organization")])] : _vm._e(), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Include send_time column"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Include "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("send_time")]), _vm._v(" column")];
      },
      proxy: true
    }], null, false, 465094418),
    model: {
      value: _vm.staged.import.send_time,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "send_time", $$v);
      },
      expression: "staged.import.send_time"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Times can be expressed as 12-hour with AM / PM or 24-hour")]), _c('v-checkbox', {
    staticClass: "mt-6",
    attrs: {
      "hide-details": "",
      "label": "Include timezone column"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Include "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("timezone")]), _vm._v(" column")];
      },
      proxy: true
    }], null, false, 20030127),
    model: {
      value: _vm.staged.import.timezone,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "timezone", $$v);
      },
      expression: "staged.import.timezone"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Must be in IATA format, e.g. " + _vm._s(_vm.TZ))]), _c('div', {
    staticClass: "mt-6 d-flex flex-wrap align-center"
  }, [_c('input-time', {
    staticClass: "mr-3",
    staticStyle: {
      "flex": "0",
      "min-width": "132px"
    },
    attrs: {
      "required": "",
      "dense": "",
      "label": "Default send time"
    },
    model: {
      value: _vm.staged.default_send_time,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "default_send_time", $$v);
      },
      expression: "staged.default_send_time"
    }
  }), _c('div', {
    staticClass: "mb-2"
  }, [_c('input-timezone', {
    model: {
      value: _vm.staged.default_timezone,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "default_timezone", $$v);
      },
      expression: "staged.default_timezone"
    }
  })], 1)], 1)], 2)]), _c('title-toggle', {
    staticClass: "title-toggle-card",
    attrs: {
      "multiple": "",
      "title": "Example template",
      "color": "primary",
      "icon": _vm.mdiTableLarge
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Example template")])];
      },
      proxy: true
    }], null, false, 793704263),
    model: {
      value: _vm.showSpreadsheetOptions,
      callback: function ($$v) {
        _vm.showSpreadsheetOptions = $$v;
      },
      expression: "showSpreadsheetOptions"
    }
  }, [_c('div', {
    staticClass: "px-6 overflow-auto text-body-2"
  }, [_c('table', {
    staticClass: "spreadsheet-example"
  }, [_c('tr', _vm._l(_vm.importFields, function (field) {
    return _c('th', [_vm._v(" " + _vm._s(field) + " ")]);
  }), 0), _vm._l(_vm.EXAMPLE_ROWS, function (row) {
    return _c('tr', _vm._l(_vm.importFields, function (field) {
      return _c('td', {
        domProps: {
          "textContent": _vm._s(row[field] || 'Example value')
        }
      });
    }), 0);
  })], 2), _c('v-btn', {
    staticClass: "my-3",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.downloadExample
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDownload)
    }
  }), _vm._v(" Download template ")], 1)], 1)]), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loadSpreadsheetStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.$refs['file-upload'].click();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  }), _vm._v(" Upload… ")], 1)], 1)], 1)], 1) : _vm._e(), _vm.showImportContacts ? _c('dialog-scroll-lock', {
    attrs: {
      "width": _vm.showContactsOptions.includes('Contact properties') ? 800 : 500
    },
    model: {
      value: _vm.showImportContacts,
      callback: function ($$v) {
        _vm.showImportContacts = $$v;
      },
      expression: "showImportContacts"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "top": "0",
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showImportContacts = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Import from Ellacard contacts")]), _c('v-card-subtitle', [_c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'account-contacts'
      }
    }
  }, [_vm._v("Manage your contacts")])], 1), _c('title-toggle', {
    staticClass: "title-toggle-card",
    attrs: {
      "multiple": "",
      "title": "Import options",
      "color": "primary",
      "icon": _vm.mdiCog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Import options")])];
      },
      proxy: true
    }], null, false, 3153190578),
    model: {
      value: _vm.showContactsOptions,
      callback: function ($$v) {
        _vm.showContactsOptions = $$v;
      },
      expression: "showContactsOptions"
    }
  }, [_c('div', {
    staticClass: "px-6 text-body-2"
  }, [_vm.staged.order.type == 'GROUP' ? [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Import contributors"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Import "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("contributors")])];
      },
      proxy: true
    }], null, false, 95483895),
    model: {
      value: _vm.staged.import.contributors,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "contributors", $$v);
      },
      expression: "staged.import.contributors"
    }
  }), _c('div', {
    staticClass: "ml-8 mb-6 text--label-active"
  }, [_vm._v("By default, all recipients of this automation are invited to sign every card except for the one addressed to them")])] : _vm._e(), (_vm$global$profile2 = _vm.global.profile) !== null && _vm$global$profile2 !== void 0 && _vm$global$profile2.org_id ? [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Import owner"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Import "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("owner")])];
      },
      proxy: true
    }], null, false, 3666858102),
    model: {
      value: _vm.staged.import.owner,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "owner", $$v);
      },
      expression: "staged.import.owner"
    }
  }), _c('div', {
    staticClass: "ml-8 mb-6 text--label-active"
  }, [_vm._v("Delegate ownership to another email address in your organization")])] : _vm._e(), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Import send time"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Import "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("send_time")])];
      },
      proxy: true
    }], null, false, 2512070689),
    model: {
      value: _vm.staged.import.send_time,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "send_time", $$v);
      },
      expression: "staged.import.send_time"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Times can be expressed as 12-hour with AM / PM or 24-hour")]), _c('v-checkbox', {
    staticClass: "mt-6",
    attrs: {
      "hide-details": "",
      "label": "Import timezone"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v("Import "), _c('code', {
          staticClass: "mx-1"
        }, [_vm._v("timezone")])];
      },
      proxy: true
    }], null, false, 698469052),
    model: {
      value: _vm.staged.import.timezone,
      callback: function ($$v) {
        _vm.$set(_vm.staged.import, "timezone", $$v);
      },
      expression: "staged.import.timezone"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("Must be in IATA format, e.g. " + _vm._s(_vm.TZ))]), _c('div', {
    staticClass: "mt-6 d-flex flex-wrap align-center"
  }, [_c('input-time', {
    staticClass: "mr-3",
    staticStyle: {
      "flex": "0",
      "min-width": "132px"
    },
    attrs: {
      "required": "",
      "dense": "",
      "label": "Default send time"
    },
    model: {
      value: _vm.staged.default_send_time,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "default_send_time", $$v);
      },
      expression: "staged.default_send_time"
    }
  }), _c('div', {
    staticClass: "mb-2"
  }, [_c('input-timezone', {
    model: {
      value: _vm.staged.default_timezone,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "default_timezone", $$v);
      },
      expression: "staged.default_timezone"
    }
  })], 1)], 1)], 2)]), _c('title-toggle', {
    ref: "select-contacts",
    staticClass: "title-toggle-card",
    attrs: {
      "multiple": "",
      "title": "Select contacts",
      "color": "primary",
      "icon": _vm.mdiAccountMultiplePlus,
      "offset": false,
      "error": !_vm.contactRowsSelected.length
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Select contacts")])];
      },
      proxy: true
    }], null, false, 913989444),
    model: {
      value: _vm.showContactsOptions,
      callback: function ($$v) {
        _vm.showContactsOptions = $$v;
      },
      expression: "showContactsOptions"
    }
  }, [_c('v-input', {
    staticClass: "d-none",
    attrs: {
      "rules": [function (v) {
        return !!v;
      }],
      "value": _vm.contactRowsSelected.length
    }
  }), _c('div', {
    staticClass: "text-body-2 pl-14 pr-6"
  }, [_c('div', {
    staticClass: "mb-3 d-flex align-center"
  }, [_c('v-checkbox', {
    staticClass: "mt-n1 ml-4 mr-3",
    attrs: {
      "hide-details": "",
      "readonly": "",
      "disabled": _vm.isLoadingContacts,
      "indeterminate": !!_vm.contactRowsSelected.length && _vm.contactRowsSelected.length != _vm.contactRows.length,
      "input-value": !!_vm.contactRowsSelected.length
    },
    on: {
      "click": function () {
        return _vm.contactRowsSelected = _vm.contactRowsSelected.length == _vm.contactRows.length ? [] : [].concat(_vm.contactRows);
      }
    }
  }), _c('contacts-search', {
    attrs: {
      "disabled": _vm.isLoadingContacts,
      "types": _vm.contactTypes
    },
    on: {
      "search": function (v) {
        return _vm.contactSearch = v;
      }
    }
  })], 1), _c('contacts-table', {
    staticClass: "flex-grow-1 overflow-auto",
    attrs: {
      "search": _vm.contactSearch,
      "types": _vm.contactTypes,
      "rows": _vm.contactRows,
      "loading": _vm.isLoadingContacts
    },
    on: {
      "update:types": function ($event) {
        _vm.contactTypes = $event;
      },
      "update:rows": function ($event) {
        _vm.contactRows = $event;
      },
      "update:loading": function ($event) {
        _vm.isLoadingContacts = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item-prefix",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-checkbox', {
          staticClass: "mt-0 mr-3",
          attrs: {
            "hide-details": "",
            "readonly": "",
            "input-value": _vm.contactRowsSelected.includes(item)
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return function () {
                return _vm.contactRowsSelected[_vm.contactRowsSelected.includes(item) ? 'remove' : 'add'](item);
              }.apply(null, arguments);
            }
          }
        })];
      }
    }], null, false, 4003914312)
  })], 1)], 1), _c('title-toggle', {
    ref: "contact-properties",
    staticClass: "title-toggle-card",
    attrs: {
      "multiple": "",
      "title": "Contact properties",
      "color": "primary",
      "icon": _vm.mdiChartSankeyVariant
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Contact properties")])];
      },
      proxy: true
    }], null, false, 4225786526),
    model: {
      value: _vm.showContactsOptions,
      callback: function ($$v) {
        _vm.showContactsOptions = $$v;
      },
      expression: "showContactsOptions"
    }
  }, [_c('div', {
    staticClass: "px-6 text-body-2"
  }, [_c('div', {
    staticClass: "text--label-active mb-3"
  }, [_vm._v("Choose how to import properties from your contacts. Contacts who are missing values for those properties will "), _c('i', [_vm._v("not")]), _vm._v(" be imported.")]), _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, _vm._l(_vm.importFields, function (key) {
    var _vm$injectContactFiel, _vm$injectContactFiel2, _vm$injectContactFiel3, _vm$injectContactFiel4, _vm$injectContactFiel13;
    return _c('div', {
      staticClass: "my-3 relative"
    }, [_c('v-input', {
      staticClass: "d-none",
      attrs: {
        "rules": [function (v) {
          return !!v;
        }],
        "value": ((_vm$injectContactFiel = _vm.injectContactFields[key]) === null || _vm$injectContactFiel === void 0 ? void 0 : _vm$injectContactFiel.contact) || ((_vm$injectContactFiel2 = _vm.injectContactFields[key]) === null || _vm$injectContactFiel2 === void 0 ? void 0 : _vm$injectContactFiel2.fixed)
      }
    }), _c('div', {
      staticClass: "absolute text--label-active ml-2 px-1 mt-n2 white",
      class: {
        'error--text': !((_vm$injectContactFiel3 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel3 !== void 0 && _vm$injectContactFiel3.contact || (_vm$injectContactFiel4 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel4 !== void 0 && _vm$injectContactFiel4.fixed)
      },
      staticStyle: {
        "z-index": "1",
        "border-radius": "4px"
      }
    }, [_vm._v(" " + _vm._s(key) + " ")]), _c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var _vm$injectContactFiel5, _vm$injectContactFiel6, _vm$injectContactFiel7, _vm$injectContactFiel8;
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            directives: [{
              name: "blur",
              rawName: "v-blur"
            }],
            staticClass: "d-block fill-width pl-3 overflow-hidden",
            staticStyle: {
              "z-index": "0",
              "text-transform": "none",
              "letter-spacing": "normal"
            },
            attrs: {
              "large": "",
              "outlined": "",
              "color": (_vm$injectContactFiel5 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel5 !== void 0 && _vm$injectContactFiel5.contact || (_vm$injectContactFiel6 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel6 !== void 0 && _vm$injectContactFiel6.fixed ? 'primary' : 'error'
            }
          }, 'v-btn', attrs, false), on), [(_vm$injectContactFiel7 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel7 !== void 0 && _vm$injectContactFiel7.contact ? _c('v-chip', {
            staticClass: "pl-1",
            staticStyle: {
              "pointer-events": "none"
            },
            attrs: {
              "color": "primary",
              "small": "",
              "label": ""
            }
          }, [_c('v-icon', {
            staticClass: "mr-2",
            domProps: {
              "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
            }
          }), _vm._v(" " + _vm._s(_vm.injectContactFields[key].contact) + " ")], 1) : (_vm$injectContactFiel8 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel8 !== void 0 && _vm$injectContactFiel8.fixed ? _c('div', {
            staticStyle: {
              "max-width": "calc(100% - 24px)",
              "text-overflow": "ellipsis",
              "overflow": "hidden",
              "color": "rgba(0, 0, 0, 0.87)"
            }
          }, [_vm._v(" " + _vm._s(_vm.injectContactFields[key].fixed) + " ")]) : _vm._e(), _c('v-spacer'), _c('v-icon', {
            staticClass: "menu-down",
            domProps: {
              "innerHTML": _vm._s(_vm.mdiMenuDown)
            }
          })], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('div', {
      staticClass: "text--label-active px-3 mb-1"
    }, [_vm._v("Contact properties")]), _vm._l(_vm.getLinkableContactFields(key), function (field) {
      var _vm$injectContactFiel9, _vm$injectContactFiel10, _vm$injectContactFiel11, _vm$injectContactFiel12;
      return [field === _vm.FIXED_FIELD ? _c('div', {
        on: {
          "!click": function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
          }
        }
      }, [_c('v-divider', {
        staticClass: "my-2"
      }), _c('div', {
        staticClass: "text--label-active px-3 mb-1"
      }, [_vm._v("Set to fixed value")]), _c('v-list-item', {
        staticClass: "simple v-list-item--link",
        attrs: {
          "input-value": !!((_vm$injectContactFiel9 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel9 !== void 0 && _vm$injectContactFiel9.fixed)
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "primary",
          "small": ""
        },
        domProps: {
          "innerHTML": _vm._s(_vm.mdiPencil)
        }
      }), field == 'owner' ? _c('v-autocomplete', {
        staticClass: "white",
        attrs: {
          "dense": "",
          "outlined": "",
          "hide-details": "",
          "items": _vm.orgUserEmails,
          "rules": [function (v) {
            return !!v;
          }],
          "value": (_vm$injectContactFiel10 = _vm.injectContactFields[key]) === null || _vm$injectContactFiel10 === void 0 ? void 0 : _vm$injectContactFiel10.fixed
        },
        on: {
          "input": function (v) {
            return _vm.$set(_vm.injectContactFields, key, {
              fixed: v
            });
          }
        }
      }) : _c('v-textarea', {
        staticClass: "white",
        attrs: {
          "dense": "",
          "rows": "1",
          "auto-grow": "",
          "hide-details": "",
          "outlined": "",
          "value": (_vm$injectContactFiel11 = _vm.injectContactFields[key]) === null || _vm$injectContactFiel11 === void 0 ? void 0 : _vm$injectContactFiel11.fixed
        },
        on: {
          "input": function (v) {
            return _vm.$set(_vm.injectContactFields, key, {
              fixed: v
            });
          }
        }
      })], 1)], 1) : _c('v-list-item', {
        staticClass: "simple",
        attrs: {
          "input-value": ((_vm$injectContactFiel12 = _vm.injectContactFields[key]) === null || _vm$injectContactFiel12 === void 0 ? void 0 : _vm$injectContactFiel12.contact) == field
        },
        on: {
          "click": function ($event) {
            return _vm.$set(_vm.injectContactFields, key, {
              contact: field
            });
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "primary",
          "small": ""
        },
        domProps: {
          "innerHTML": _vm._s(_vm.SEARCH_FIELD_TYPES[_vm.contactTypes[field]])
        }
      }), _c('div', [_c('v-chip', {
        staticClass: "pl-1",
        attrs: {
          "color": "primary",
          "small": "",
          "label": ""
        }
      }, [_c('v-icon', {
        staticClass: "mr-2",
        domProps: {
          "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
        }
      }), _vm._v(" " + _vm._s(field) + " ")], 1)], 1)], 1)];
    })], 2)], 1), _vm.$vuetify.breakpoint.smAndUp ? _c('div', [(_vm$injectContactFiel13 = _vm.injectContactFields[key]) !== null && _vm$injectContactFiel13 !== void 0 && _vm$injectContactFiel13.contact ? _c('connector', {
      attrs: {
        "id": 'icon-' + key,
        "from": 'icon-' + key,
        "to": 'contact-field-' + _vm.injectContactFields[key].contact,
        "z-index": 204
      }
    }) : _vm._e(), _vm._v("   ")], 1) : _vm._e()], 1)], 1);
  }), 0), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, _vm._l(_vm.contactTypes, function (fieldType, fieldKey) {
    var _vm$contactRowsSelect;
    return _c('div', {
      staticClass: "py-3 relative"
    }, [_c('div', {
      staticClass: "text--label-active"
    }, [_c('span', {
      staticClass: "ml-n2 mr-2",
      attrs: {
        "id": 'contact-field-' + fieldKey
      }
    }), _c('span', {
      class: {
        'primary--text': Object.entries(_vm.injectContactFields).filter(function (_ref3) {
          var k = _ref3[0];
          return _vm.importFields.includes(k);
        }).map(function (_ref4) {
          var _ = _ref4[0],
            v = _ref4[1];
          return v.contact;
        }).includes(fieldKey)
      }
    }, [_vm._v(_vm._s(fieldKey))])]), _c({
      address: 'ContactFieldAddress',
      date: 'ContactFieldDate',
      'phone number': 'ContactFieldPhone'
    }[fieldType] || 'VTextField', {
      tag: "component",
      staticClass: "mt-0 flex-no-wrap",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": "",
        "value": (((_vm$contactRowsSelect = _vm.contactRowsSelected[0]) === null || _vm$contactRowsSelect === void 0 ? void 0 : _vm$contactRowsSelect.contact) || {})[fieldKey]
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-icon', {
            attrs: {
              "small": ""
            },
            domProps: {
              "innerHTML": _vm._s(_vm.SEARCH_FIELD_TYPES[fieldType])
            }
          })];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0)])], 1)], 1)], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.isLoadingContacts || _vm.loadContactsStatus.pending
    },
    on: {
      "click": function () {
        return ['select-contacts', 'contact-properties'].every(function (x) {
          return _vm.$refs[x].$refs.form.validate();
        }) ? _vm.loadContacts() : _vm.promptFix;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccountCheck)
    }
  }), _vm._v(" Load contacts ")], 1)], 1)], 1)], 1) : _vm._e(), _vm.selectedRow ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "persistent": !_vm.selectedRowIsValid,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selectedRow = null;
      },
      "click:outside": function ($event) {
        return _vm.updateSelectedRow(true);
      }
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('div', {
    staticClass: "relative",
    staticStyle: {
      "height": "222px"
    },
    style: {
      'background-color': _vm.staged.order.skin.page_background_color || '#FFF'
    },
    on: {
      "click": function ($event) {
        _vm.showPreview = true;
      }
    }
  }, [_vm.staged.order.skin.page_background_img ? _c('card-background', {
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "src": _vm.staged.order.skin.page_background_img
    }
  }) : _vm._e(), _c('confetti', {
    staticClass: "absolute-fill overflow-hidden",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "effect": _vm.staged.order.skin.open_effect,
      "active": true
    }
  }), _vm.selectedRowPreview ? _c('div', {
    staticClass: "relative mx-auto pa-3 d-flex align-center",
    staticStyle: {
      "z-index": "3",
      "max-width": "320px"
    }
  }, [_c('envelope', {
    staticClass: "ma-3",
    staticStyle: {
      "flex": "1",
      "width": "50%",
      "aspect-ratio": "1"
    },
    attrs: {
      "from": _vm.selectedRowPreview.info.from,
      "to": _vm.selectedRowPreview.info.to,
      "skin": _vm.selectedRowPreview.skin
    }
  }), _c('card-preview', {
    staticClass: "ma-3 v-card v-sheet elevation-6",
    staticStyle: {
      "flex": "1",
      "width": "50%"
    },
    attrs: {
      "mode": "view",
      "card": _vm.selectedRowPreview
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "preview-section btn-tooltip-container d-flex align-center justify-center overflow-visible",
    staticStyle: {
      "z-index": "5"
    }
  }, [_c('div', {
    staticClass: "btn-tooltip center prominent d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "white"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiArrowExpandAll)
    }
  }), _vm._v(" Preview as recipient…")], 1)])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "overflow-scroll pt-6",
    staticStyle: {
      "max-height": "calc(90vh - 222px - 1px - 1px - 52px)"
    }
  }, [_vm.getNextCreated(_vm.selectedRow) ? _c('div', {
    staticClass: "pb-6 text--label-active font-italic warning--text d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _c('div', [_vm._v(" Next card already created " + _vm._s(_vm._f("moment")(_vm.getNextCreated(_vm.selectedRow).created_at)) + " – "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account-orders',
        params: {
          orderId: _vm.getNextCreated(_vm.selectedRow).order_id
        }
      }
    }
  }, [_vm._v("open card")])], 1)], 1) : _vm._e(), _c('v-form', {
    ref: "row-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.selectedRowIsValid,
      callback: function ($$v) {
        _vm.selectedRowIsValid = $$v;
      },
      expression: "selectedRowIsValid"
    }
  }, [_c('v-row', [_vm._l(_vm.customFields, function (key) {
    return _c('v-col', {
      key: key,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-textarea', {
      staticClass: "white inline-error",
      attrs: {
        "dense": "",
        "outlined": "",
        "persistent-placeholder": "",
        "auto-grow": "",
        "rows": "1",
        "persistent-hint": "",
        "disabled": _vm.NON_MODIFIABLE_KEYS.has(key),
        "hint": _vm.NON_MODIFIABLE_KEYS.has(key) ? 'Format of this field is not editable' : null,
        "label": key,
        "rules": [function (v) {
          return !!v || 'Required';
        }]
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_c('span', {
            staticClass: "white"
          }, [_vm._v("{ " + _vm._s(key) + " }")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.selectedRow[key],
        callback: function ($$v) {
          _vm.$set(_vm.selectedRow, key, $$v);
        },
        expression: "selectedRow[key]"
      }
    })], 1);
  }), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('email-phone-field', {
    attrs: {
      "required": "",
      "label": "Email address / phone number",
      "rules": [function (v) {
        if (!v) return true;
        if (_vm.selectedRowI != -1 && v.toLowerCase() == _vm.staged.rows[_vm.selectedRowI].recipient.toLowerCase()) return true;
        if (!_vm.rowsByRecipientLower[v.toLowerCase()]) return true;
        return 'Duplicate recipient';
      }]
    },
    model: {
      value: _vm.selectedRow.recipient,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRow, "recipient", $$v);
      },
      expression: "selectedRow.recipient"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap ma-n2"
  }, [_c('div', {
    staticClass: "ma-2 btn-group btn-group-horizontal d-flex flex-grow-1",
    staticStyle: {
      "width": "280px"
    }
  }, [_c('v-select', {
    ref: "send-date-month",
    staticClass: "white flex-grow-1 inline-error",
    staticStyle: {
      "width": "180px",
      "margin-right": "-1px"
    },
    attrs: {
      "dense": "",
      "label": "Send date",
      "outlined": "",
      "persistent-placeholder": "",
      "persistent-hint": "",
      "hint": _vm.selectedRow.send_date == '02-29' ? 'February 28th in non-leap years' : null,
      "rules": _vm.sendDateRules,
      "items": Object.keys(_vm.EN_MONTHS).map(function (x, i) {
        return {
          text: x.slice(0, 1).toUpperCase() + x.slice(1),
          value: String(i + 1).padStart(2, '0')
        };
      }),
      "value": _vm.selectedRow.send_date ? _vm.selectedRow.send_date.split('-')[0] : null
    },
    on: {
      "input": function (v) {
        var _vm$selectedRow$send_;
        _vm.selectedRow.send_date = (v || '00') + '-' + (((_vm$selectedRow$send_ = _vm.selectedRow.send_date) === null || _vm$selectedRow$send_ === void 0 ? void 0 : _vm$selectedRow$send_.split('-')[1]) || '00');
        _this.$refs['send-date-day'].validate();
      }
    }
  }), _c('v-select', {
    ref: "send-date-day",
    staticClass: "white flex-grow-1",
    staticStyle: {
      "width": "80px",
      "margin-left": "-1px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "persistent-placeholder": "",
      "rules": _vm.sendDateRules,
      "items": Array.from({
        length: _vm.selectedRow.send_date && Object.values(_vm.EN_MONTHS)[parseInt(_vm.selectedRow.send_date.split('-')[0]) - 1] || 31
      }, function (_, i) {
        return {
          text: i + 1 + _vm.getOrdinalSuffixEN(i + 1),
          value: i + 1
        };
      }),
      "value": _vm.selectedRow.send_date ? parseInt(_vm.selectedRow.send_date.split('-')[1]) : null
    },
    on: {
      "input": function (v) {
        var _vm$selectedRow$send_2;
        _vm.selectedRow.send_date = (((_vm$selectedRow$send_2 = _vm.selectedRow.send_date) === null || _vm$selectedRow$send_2 === void 0 ? void 0 : _vm$selectedRow$send_2.split('-')[0]) || '00') + '-' + String(v || 0).padStart(2, '0');
        _this.$refs['send-date-month'].validate();
      }
    }
  })], 1), _c('input-time', {
    ref: "time",
    staticClass: "ma-2",
    staticStyle: {
      "max-width": "106px"
    },
    attrs: {
      "dense": "",
      "label": "Time",
      "rules": [function (v) {
        return !!v || 'Required';
      }]
    },
    model: {
      value: _vm.selectedRow.send_time,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRow, "send_time", $$v);
      },
      expression: "selectedRow.send_time"
    }
  })], 1), _c('input-timezone', {
    model: {
      value: _vm.selectedRow.timezone,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRow, "timezone", $$v);
      },
      expression: "selectedRow.timezone"
    }
  })], 1), (_vm$global$profile3 = _vm.global.profile) !== null && _vm$global$profile3 !== void 0 && _vm$global$profile3.org_id ? _c('v-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "Delegate ownership",
      "input-value": _vm.selectedRow.owner != undefined
    },
    on: {
      "change": function () {
        return _vm.selectedRow.owner == undefined ? _vm.$set(_vm.selectedRow, 'owner', '') : _vm.$delete(_vm.selectedRow, 'owner');
      }
    }
  }), _vm.selectedRow.owner == undefined ? _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v(" Delegate responsibility for managing the card after it has been ordered to someone else in your organization ")]) : _c('v-select', {
    staticClass: "ml-8 mt-2 white",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "persistent-placeholder": "",
      "label": "Owner",
      "rules": [function (v) {
        return !!v;
      }],
      "items": _vm.orgUserEmails
    },
    model: {
      value: _vm.selectedRow.owner,
      callback: function ($$v) {
        _vm.$set(_vm.selectedRow, "owner", $$v);
      },
      expression: "selectedRow.owner"
    }
  })], 1) : _vm._e(), _vm.staged.order.type == 'GROUP' ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v(" Group signing contributors (" + _vm._s(_vm.selectedRowContributorsImplicit.length + _vm.selectedRowContributorsExplicit.length) + ") ")]), _vm._l(_vm.selectedRowContributorsImplicit, function (target) {
    return _c('div', {
      staticClass: "mt-2 d-flex align-center"
    }, [_c('email-phone-field', {
      staticClass: "flex-grow-1 mr-3",
      attrs: {
        "disabled": "",
        "value": target
      }
    }), _c('v-btn', {
      attrs: {
        "disabled": "",
        "icon": "",
        "color": "warning"
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiMinus)
      }
    })], 1)], 1);
  }), !_vm.staged.all_contributors ? [_vm._l(_vm.selectedRowContributorsExplicit, function (target, i) {
    return _c('div', {
      staticClass: "mt-2 d-flex align-center"
    }, [_c('email-phone-field', {
      staticClass: "flex-grow-1 mr-3",
      attrs: {
        "required": "",
        "rules": [function (v) {
          return !v || !_vm.selectedRow.recipient || v.toLowerCase() != _vm.selectedRow.recipient.toLowerCase() || 'Cannot sign own card';
        }, function (v) {
          return !v || !_vm.selectedRowContributorsImplicit.find(function (x) {
            return v.toLowerCase() == x.toLowerCase();
          }) || 'Already a permanent contributor';
        }, function (v) {
          return !v || !_vm.selectedRowContributorsExplicit.find(function (x, j) {
            return j != i && v.toLowerCase() == x.toLowerCase();
          }) || 'Duplicate';
        }]
      },
      model: {
        value: _vm.selectedRowContributorsExplicit[i],
        callback: function ($$v) {
          _vm.$set(_vm.selectedRowContributorsExplicit, i, $$v);
        },
        expression: "selectedRowContributorsExplicit[i]"
      }
    }), _c('v-btn', {
      attrs: {
        "icon": "",
        "color": "warning"
      },
      on: {
        "click": function ($event) {
          _vm.selectedRowContributorsExplicit.splice(i, 1);
          _vm.$refs['row-form'].validate();
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiMinus)
      }
    })], 1)], 1);
  }), _c('div', {
    staticClass: "mt-2 text-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.selectedRowContributorsExplicit.push('');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: !_vm.getNContributors(_vm.selectedRow)
    }
  }, [_vm._v(" Add contributor ")])], 1)], 1)] : _vm._e()], 2) : _vm._e()], 2)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_vm.selectedRowI == -1 ? [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.selectedRow = null;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.updateSelectedRow(true);
      }
    }
  }, [_vm._v("Add")])] : [_c('v-btn', {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "unset"
    },
    on: {
      "click": _vm.deleteSelectedRow
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Delete")])], 1), _c('v-btn', {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "disabled": !_vm.selectedRow.recipient
    },
    on: {
      "click": function ($event) {
        _vm.showSelectedRowHistory = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHistory)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Automation history")])], 1), _c('v-btn', {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "loading": _vm.createNextStatus.pending
    },
    on: {
      "click": _vm.createNext
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCartArrowRight)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Create next card")])], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.updateSelectedRow(true);
      }
    }
  }, [_vm._v("Close")])]], 2)], 1)], 1) : _vm._e(), _vm.showSelectedRowHistory ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "520"
    },
    model: {
      value: _vm.showSelectedRowHistory,
      callback: function ($$v) {
        _vm.showSelectedRowHistory = $$v;
      },
      expression: "showSelectedRowHistory"
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4 py-2"
  }, [_c('v-data-table', {
    staticClass: "row-pointer transparent",
    attrs: {
      "no-data-text": "No previous orders found",
      "must-sort": "",
      "sort-desc": "",
      "sort-by": "order.created_at",
      "items-per-page": 50,
      "footer-props": {
        disableItemsPerPage: true,
        itemsPerPageOptions: [50]
      },
      "headers": _vm.HISTORY_HEADERS,
      "items": _vm.selectedRowHistory,
      "loading": _vm.loadSelectedRowHistoryStatus.pending
    },
    on: {
      "click:row": function (x) {
        return _vm.$router.push({
          name: 'account-orders',
          params: {
            orderId: x.order_id
          }
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "header.action",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              _vm.showSelectedRowHistory = false;
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiClose)
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "item.order",
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('v-lazy', {
          staticClass: "my-1 my-sm-2",
          staticStyle: {
            "aspect-ratio": "5 / 7",
            "width": "60px"
          }
        }, [_c('account-order-preview', {
          attrs: {
            "mode": "view",
            "width": 60,
            "order": value,
            "is-card-owner": value.user_id == _vm.globalUserId
          }
        })], 1)];
      }
    }, {
      key: "item.order.created_at",
      fn: function (_ref6) {
        var value = _ref6.value;
        return [_vm._v(" " + _vm._s(_vm._f("moment")(value, 'short')) + " ")];
      }
    }, {
      key: "item.order.automation_send_at",
      fn: function (_ref7) {
        var item = _ref7.item,
          value = _ref7.value;
        return [_c('div', {
          class: {
            'text-decoration-line-through': item.order.info.send_at != value
          }
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(value, 'short')) + " ")]), item.order.info.send_at && item.order.info.send_at != value ? _c('div', [_vm._v(" " + _vm._s(_vm._f("moment")(item.order.info.send_at, 'short')) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.action",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "hidden-xs-only",
          attrs: {
            "icon": "",
            "color": "primary"
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 4084115546)
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "flex-grow-0 pa-3 elevation-6 overflow-visible d-flex align-center",
    staticStyle: {
      "z-index": "2"
    }
  }, [_vm.$vuetify.breakpoint.smAndDown && _vm.$route.hash ? _c('v-btn', {
    attrs: {
      "exact": "",
      "icon": "",
      "color": "ec-dark-blue",
      "to": _vm.$routeAssign({
        hash: undefined
      })
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  })], 1) : _vm.$vuetify.breakpoint.mdAndUp ? _c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "exact": "",
      "text": "",
      "color": "ec-dark-blue",
      "to": _vm.back ? _vm.$routeAssign({
        hash: '#' + _vm.back
      }) : _vm.routeOnClose
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" Back ")], 1) : _vm._e(), _c('div', {
    staticClass: "mx-auto ec-dark-blue--text title font-weight-bold",
    staticStyle: {
      "white-space": "nowrap",
      "text-overflow": "ellipsis",
      "overflow": "hidden"
    }
  }, [_vm.step ? [_c('v-icon', {
    attrs: {
      "color": "ec-dark-blue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.step.icon)
    }
  }), _vm._v(" " + _vm._s(_vm.step.name) + " ")] : [_vm._v("Automation")]], 2), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "ec-dark-blue",
      "exact": "",
      "to": _vm.routeOnClose
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _vm.loadStatus.pending ? _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : !_vm.staged ? _c('div', {
    staticClass: "flex-grow-1 d-flex flex-column justify-center align-center text-center pa-4"
  }, [_c('div', {
    staticClass: "title warning--text"
  }, [_vm._v("Automation not found")]), _c('div', {
    staticClass: "mt-12 text-body-2"
  }, [_vm._v(" Think you're seeing this page in error? Please let us know!"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@ellacard.com"
    }
  }, [_vm._v("support@ellacard.com")])])]) : _c('div', {
    staticClass: "flex-grow-1 d-flex relative",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('v-slide-x-transition', [_vm.$vuetify.breakpoint.mdAndUp || !_vm.$route.hash ? _c('div', {
    staticClass: "grey lighten-3 overflow-auto fill-width d-md-flex flex-md-column",
    style: _vm.$vuetify.breakpoint.mdAndUp ? {
      'min-width': '300px',
      'max-width': '300px'
    } : {}
  }, [_c('div', {
    staticClass: "pt-6 px-3 pb-3 overflow-auto",
    staticStyle: {
      "flex": "none",
      "white-space": "nowrap"
    }
  }, _vm._l(_vm.staged.design_ids.length ? _vm.staged.design_ids : [_vm.blankDesignId], function (id, i) {
    return _c('v-lazy', {
      key: 'left-' + id,
      staticClass: "d-inline-block",
      staticStyle: {
        "aspect-ratio": "5 / 7",
        "width": "80px",
        "flex": "none"
      }
    }, [_c('card-preview', {
      staticClass: "v-card v-sheet",
      style: {
        transform: _vm.staged.design_ids.length > 1 ? `rotate(${(1 + i % 2 * -2) * 5}deg)` : null
      },
      attrs: {
        "mode": "view",
        "width": 80,
        "card": _vm.stagedDesigns[i] || _vm.blankDesign
      }
    })], 1);
  }), 1), _c('div', [_c('div', {
    staticClass: "my-4 ml-1 mr-2 relative btn-tooltip-container d-flex justify-center"
  }, [_c('v-textarea', {
    ref: "name",
    staticClass: "border-focus",
    class: {
      white: _vm.showEditName
    },
    attrs: {
      "label": "Automation name",
      "dense": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "1",
      "hide-details": "",
      "persistent-placeholder": "",
      "rules": [function (v) {
        return !!v;
      }],
      "readonly": !_vm.showEditName
    },
    on: {
      "focus": function ($event) {
        _vm.showEditName = true;
      },
      "blur": function ($event) {
        _vm.showEditName = false;
        _vm.clearSelection();
        _vm.isSignedIn && _vm.staged.name != _vm.loaded.name && _vm.save();
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.$refs.name.blur();
      }
    },
    model: {
      value: _vm.staged.name,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "name", $$v);
      },
      expression: "staged.name"
    }
  }), _c('v-btn', {
    staticStyle: {
      "top": "calc(100% - 8px)",
      "right": "-4px"
    },
    style: _vm.showEditName ? {} : {
      opacity: 0,
      'pointer-events': 'none'
    },
    attrs: {
      "absolute": "",
      "small": "",
      "color": "primary",
      "loading": _vm.saveStatus.pending
    }
  }, [_vm._v(" " + _vm._s(_vm.isSignedIn && _vm.staged.name != _vm.loaded.name ? 'Save' : 'Done') + " ")]), !_vm.showEditName ? _c('span', {
    staticClass: "mt-n5 ml-3 btn-tooltip bottom right"
  }, [_vm._v("Edit automation name")]) : _vm._e()], 1), _c('div', {
    staticClass: "mt-6 mx-4"
  }, [_vm.loaded.state == 'ACTIVE' ? _c('div', {
    staticStyle: {
      "color": "rgb(0, 0, 0, .87)"
    }
  }, [_c('div', {
    staticClass: "text--label-active",
    staticStyle: {
      "margin-top": "-11px"
    }
  }, [_vm._v("Next order creation date")]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.staged.next_at ? [_vm._v(_vm._s(_vm._f("moment")(_vm.staged.next_at, 'short')))] : [_vm._v("–")], _c('v-spacer'), _c('v-btn', {
    staticClass: "ml-1 my-n2",
    attrs: {
      "icon": "",
      "color": "warning",
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPause)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom left"
  }, [_vm._v("Pause automation")])], 1)], 2)]) : [_vm.loaded.last_error ? _c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    on: {
      "click": function ($event) {
        var _vm$loaded$last_error;
        _vm.$confirm({
          title: 'Automation error',
          msg: `This automation has been automatically paused because it encountered an error last time it tried to create an order. Please fix the problem first, then restart the automation.<br><br>Failed: ${_vm.$options.filters.moment(_vm.loaded.last_error.at)}<br>Error code: ${_vm.loaded.last_error.error}<br>Recipient: ${((_vm$loaded$last_error = _vm.loaded.last_error.row) === null || _vm$loaded$last_error === void 0 ? void 0 : _vm$loaded$last_error.recipient) || '?'}`,
          buttons: ['Cancel', 'Start automation'],
          primary: 'Cancel'
        }).then(function (x) {
          return x == 'Start automation' && _vm.start();
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Start automation ")], 1) : _c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.start
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlay)
    }
  }), _vm._v(" Start automation ")], 1)], _vm.expired ? _c('div', {
    staticClass: "mt-6 d-flex align-center",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('div', {
    staticClass: "text--label-active error--text"
  }, [_vm._v(" Your version of this automation is likely out of date – please reload ")]), _c('v-btn', {
    staticClass: "ml-1 my-n2 pulse",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go();
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "-2px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiReload)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom left"
  }, [_vm._v("Reload page")])], 1)], 1) : _vm._e()], 2)]), _c('div', {
    staticClass: "flex-grow-1 pt-12 pb-6 d-flex flex-column ec-dark-blue--text"
  }, [_c('div', {
    staticClass: "mb-12"
  }, _vm._l(_vm.steps, function (step) {
    return _c('v-list-item', {
      key: step.key,
      staticClass: "simple li-pop pl-4",
      class: {
        'error--text': _vm.staged.dirty.includes(step.key) && step.error
      },
      attrs: {
        "to": _vm.$routeAssign({
          hash: '#' + step.key
        })
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(step.icon)
      }
    }), _c('div', [_vm._v(_vm._s(step.name))]), _vm.staged.dirty.includes(step.key) ? _c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(step.error ? _vm.iconPathExclamation : _vm.mdiCheck)
      }
    }) : _vm.$vuetify.breakpoint.smAndDown ? _c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    }) : _vm._e()], 1);
  }), 1), _c('v-spacer'), _vm.id ? _c('div', {
    staticClass: "pb-12 pb-md-0"
  }, [_c('v-list-item', {
    staticClass: "simple py-2 mb-n1",
    attrs: {
      "aria-expanded": String(_vm.showMore)
    },
    on: {
      "click": function ($event) {
        _vm.showMore = !_vm.showMore;
      }
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("More")]), _c('v-icon', {
    staticClass: "menu-down",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMenuDown)
    }
  })], 1)]), _c('v-expand-transition', [_vm.showMore ? _c('div', [_c('v-list-item', {
    staticClass: "simple li-pop pl-4",
    on: {
      "click": _vm.copyAutomation
    }
  }, [_vm.copyAutomationStatus.pending ? _c('v-progress-circular', {
    staticStyle: {
      "transform": "none !important"
    },
    attrs: {
      "indeterminate": "",
      "size": "24",
      "width": "2"
    }
  }) : _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiContentCopy)
    }
  }), _c('div', [_vm._v("Copy to new automation")])], 1), _c('v-list-item', {
    staticClass: "simple li-pop pl-4 warning--text",
    attrs: {
      "loading": true
    },
    on: {
      "click": _vm.deleteAutomation
    }
  }, [_vm.deleteAutomationStatus.pending ? _c('v-progress-circular', {
    staticStyle: {
      "transform": "none !important"
    },
    attrs: {
      "indeterminate": "",
      "size": "24",
      "width": "2"
    }
  }) : _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  }), _c('div', [_vm._v("Delete automation…")])], 1)], 1) : _vm._e()])], 1) : _vm._e()], 1)]) : _vm._e()]), _c('v-divider', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "vertical": ""
    }
  }), _vm.$vuetify.breakpoint.mdAndUp || _vm.$route.hash ? _c('div', {
    staticClass: "flex-grow-1 fill-height overflow-auto",
    class: {
      'absolute-fill': _vm.$vuetify.breakpoint.smAndDown
    },
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm.$route.hash == '#type' ? _c('div', [_c('title-toggle', {
    attrs: {
      "title": "What type of cards do you want to automate?",
      "icon": _vm.steps.find(function (x) {
        return x.key == 'type';
      }).icon
    },
    model: {
      value: _vm.showType,
      callback: function ($$v) {
        _vm.showType = $$v;
      },
      expression: "showType"
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.staged.order.type,
      callback: function ($$v) {
        _vm.$set(_vm.staged.order, "type", $$v);
      },
      expression: "staged.order.type"
    }
  }, [_c('v-radio', {
    staticClass: "mt-0",
    attrs: {
      "label": "Personal cards",
      "value": "PERSONAL"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "mr-6"
        }, [_c('div', [_vm._v("Personal cards")]), _c('div', {
          staticClass: "text--label-active"
        }, [_vm._v("Signed by you only")])]), _c('v-spacer'), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathCardPersonal)
          }
        })];
      },
      proxy: true
    }], null, false, 1042645457)
  }), _c('v-radio', {
    staticClass: "mt-3",
    attrs: {
      "label": "Group cards",
      "value": "GROUP"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "mr-6"
        }, [_c('div', [_vm._v("Group cards")]), _c('div', {
          staticClass: "text--label-active"
        }, [_vm._v("Invite contributors to sign")])]), _c('v-spacer'), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathCardGroup)
          }
        })];
      },
      proxy: true
    }], null, false, 2927906510)
  })], 1)], 1), _c('title-toggle', {
    ref: "type:designs",
    attrs: {
      "title": "What card design(s) do you want to use?",
      "icon": _vm.mdiImageAlbum
    },
    model: {
      value: _vm.showType,
      callback: function ($$v) {
        _vm.showType = $$v;
      },
      expression: "showType"
    }
  }, [_c('v-input', {
    staticClass: "d-none",
    attrs: {
      "rules": [function (v) {
        return !!v.length;
      }],
      "value": _vm.staged.design_ids
    }
  }), _c('div', [_vm._v("If you select multiple card designs, we'll distribute them across all the recipients so everyone doesn't get the same card. Note that some designs have editable text or image slots – make sure you update those in the "), _c('router-link', {
    attrs: {
      "to": {
        hash: '#design'
      }
    }
  }, [_vm._v("design step")]), _vm._v(" if needed.")], 1), _c('div', {
    staticClass: "my-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showSelectDesigns = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCards)
    }
  }), _vm._v("Select design(s) from catalog… ")], 1)], 1), _c('v-row', {
    staticClass: "my-0"
  }, _vm._l(_vm.staged.design_ids, function (id, i) {
    return _c('v-col', {
      key: 'type-' + id,
      staticClass: "relative",
      attrs: {
        "cols": "6",
        "sm": "3"
      }
    }, [_c('v-btn', {
      staticStyle: {
        "z-index": "1",
        "top": "0",
        "right": "0"
      },
      attrs: {
        "absolute": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.staged.design_ids.splice(i, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "warning"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiDelete)
      }
    }), _c('span', {
      staticClass: "btn-tooltip bottom left"
    }, [_vm._v("Remove this cover")])], 1), _c('v-lazy', {
      staticStyle: {
        "aspect-ratio": "5 / 7"
      }
    }, [_vm.stagedDesigns[i] ? _c('card-preview', {
      staticClass: "v-card v-card--hover v-sheet",
      attrs: {
        "mode": "edit",
        "card": _vm.stagedDesigns[i]
      },
      nativeOn: {
        "click": function ($event) {
          _vm.curDesignId = id;
          _vm.$router.push({
            hash: '#design'
          });
        }
      }
    }) : _vm._e()], 1)], 1);
  }), 1)], 1)], 1) : _vm.$route.hash == '#design' ? _c('div', {
    staticClass: "fill-height d-flex flex-column"
  }, [_vm.attachCurDesignIdStatus.pending ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : [_c('order-stepper-card-editor', {
    staticClass: "overflow-auto relative",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "order": _vm.staged.order,
      "automation": true
    }
  }), _vm.staged.design_ids.length > 1 ? _c('div', {
    staticClass: "flex-grow-0 relative",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('v-divider'), _c('div', {
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: function (_ref8) {
        var height = _ref8.height;
        return _vm.designCoverPreviewW = 5 * (height - (_vm.$vuetify.breakpoint.xsOnly ? 8 : 16)) / 7;
      },
      expression: "({ height }) => designCoverPreviewW = 5 * (height - ($vuetify.breakpoint.xsOnly ? 8 : 16)) / 7"
    }],
    staticClass: "overflow-auto d-flex pa-1",
    staticStyle: {
      "height": "136px",
      "max-height": "20vw"
    }
  }, _vm._l(_vm.staged.design_ids, function (id, i) {
    return _vm.designCoverPreviewW ? _c('card-preview', {
      key: 'design-' + id,
      staticClass: "ma-1 ma-sm-2 v-card v-card--hover v-sheet flex-grow-0",
      class: {
        highlight: id == _vm.curDesignId
      },
      attrs: {
        "mode": "edit",
        "width": _vm.designCoverPreviewW,
        "card": _vm.stagedDesigns[i] || _vm.blankDesign
      },
      nativeOn: {
        "click": function ($event) {
          _vm.curDesignId = id;
        }
      }
    }) : _vm._e();
  }), 1)], 1) : _vm._e()]], 2) : _vm.$route.hash == '#envelope' ? _c('order-stepper-theme', {
    ref: "envelope",
    staticClass: "fill-height",
    attrs: {
      "order": _vm.staged.order,
      "org-skin": _vm.orgSkin,
      "show-help": _vm.global.showHelp,
      "disable-multiple-recipients": true
    }
  }) : _vm.$route.hash == '#group-signing' ? _c('div', [_c('title-toggle', {
    ref: "group-signing",
    attrs: {
      "title": "Group signing contributors",
      "icon": _vm.mdiEmailEdit
    },
    model: {
      value: _vm.showGroupSigning,
      callback: function ($$v) {
        _vm.showGroupSigning = $$v;
      },
      expression: "showGroupSigning"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Invite all recipients to sign every card",
      "hide-details": ""
    },
    model: {
      value: _vm.staged.all_contributors,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "all_contributors", $$v);
      },
      expression: "staged.all_contributors"
    }
  }), _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v("Except for the one addressed to them")]), _c('v-checkbox', {
    attrs: {
      "label": "Set permanent contributors",
      "hide-details": "",
      "input-value": !!_vm.staged.permanent_contributors.length
    },
    on: {
      "change": function (v) {
        return _vm.staged.permanent_contributors = v ? [''] : [];
      }
    }
  }), _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v("These contributors will be invited to sign every card")]), _vm.staged.permanent_contributors.length ? _c('div', {
    staticClass: "pl-8",
    staticStyle: {
      "max-width": "360px"
    }
  }, [_vm._l(_vm.staged.permanent_contributors, function (_, i) {
    return _c('div', {
      staticClass: "mt-2 d-flex align-center"
    }, [_c('email-phone-field', {
      staticClass: "flex-grow-1 mr-3 ml-n12",
      attrs: {
        "fixed": "",
        "required": "",
        "rules": [function (v) {
          return !v || _vm.staged.permanent_contributors.every(function (x, j) {
            return i == j || !x || v.toLowerCase() != x.toLowerCase();
          }) || 'Duplicate';
        }]
      },
      model: {
        value: _vm.staged.permanent_contributors[i],
        callback: function ($$v) {
          _vm.$set(_vm.staged.permanent_contributors, i, $$v);
        },
        expression: "staged.permanent_contributors[i]"
      }
    }), _c('v-btn', {
      attrs: {
        "icon": "",
        "color": "warning"
      },
      on: {
        "click": function ($event) {
          return _vm.staged.permanent_contributors.splice(i, 1);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiMinus)
      }
    })], 1)], 1);
  }), _c('div', {
    staticClass: "mt-2 text-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.staged.permanent_contributors.push('');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left"
  }, [_vm._v(" Add permanent contributor ")])], 1)], 1)], 2) : _vm._e()], 1), _c('title-toggle', {
    attrs: {
      "title": "Group signing options",
      "icon": _vm.mdiCog
    },
    model: {
      value: _vm.showGroupSigning,
      callback: function ($$v) {
        _vm.showGroupSigning = $$v;
      },
      expression: "showGroupSigning"
    }
  }, [_c('v-textarea', {
    staticClass: "white inline-error",
    attrs: {
      "outlined": "",
      "no-resize": "",
      "rows": "3",
      "persistent-placeholder": "",
      "label": "Add a custom message for contributors",
      "rules": _vm.buildRules({
        limit: 500
      })
    },
    model: {
      value: _vm.staged.order.msg,
      callback: function ($$v) {
        _vm.$set(_vm.staged.order, "msg", $$v);
      },
      expression: "staged.order.msg"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Private signing"
    },
    model: {
      value: _vm.staged.order.skin.private_pages,
      callback: function ($$v) {
        _vm.$set(_vm.staged.order.skin, "private_pages", $$v);
      },
      expression: "staged.order.skin.private_pages"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v(" Prevent contributors from viewing content created by others ")]), _vm.orgSkin.max_giftcard_value != 0 ? [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Prevent others from adding gift cards"
    },
    model: {
      value: _vm.staged.order.skin.disable_contributor_giftcards,
      callback: function ($$v) {
        _vm.$set(_vm.staged.order.skin, "disable_contributor_giftcards", $$v);
      },
      expression: "staged.order.skin.disable_contributor_giftcards"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Hide gift card totals from other contributors",
      "disabled": !!_vm.staged.order.skin.private_pages,
      "input-value": !!_vm.staged.order.skin.hide_giftcard_totals || !!_vm.staged.order.skin.private_pages
    },
    on: {
      "change": function (x) {
        return _vm.staged.order.skin.hide_giftcard_totals = x;
      }
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v(" This will also prevent other contributors from adding value to any of your gift cards ")])] : _vm._e(), _c('v-checkbox', {
    attrs: {
      "label": "Delay inviting contributors…",
      "hide-details": "",
      "readonly": "",
      "disabled": "",
      "input-value": true
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v(" For automations, this value is taken from the "), _c('i', [_vm._v("create orders in advance")]), _vm._v(" setting in the "), _c('router-link', {
    attrs: {
      "to": {
        hash: 'payment'
      }
    },
    nativeOn: {
      "!click": function ($event) {
        _vm.showPayment = ['Placing orders'];
      }
    }
  }, [_vm._v("orders / payment")]), _vm._v(" step ")], 1), _c('v-radio-group', {
    staticClass: "ml-8 py-0 mt-3",
    attrs: {
      "hide-details": "",
      "disabled": "",
      "value": true
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Days before the card is scheduled to send to the recipient",
      "disabled": "",
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', [_c('span', {
          staticClass: "px-1 mx-n1",
          staticStyle: {
            "text-decoration": "underline"
          }
        }, [_vm._v(_vm._s(_vm._f("pl")(_vm.staged.n_days_in_advance, 'day')))]), _vm._v(" before the card is scheduled to send to the recipient ")])];
      },
      proxy: true
    }], null, false, 1048716127)
  }), _c('v-radio', {
    staticClass: "mt-2",
    attrs: {
      "label": "Exact time…",
      "disabled": ""
    }
  })], 1)], 2)], 1) : _vm.$route.hash == '#delivery' ? _c('div', [_c('title-toggle', {
    ref: "delivery:recipients",
    attrs: {
      "title": "Recipients",
      "icon": _vm.iconPathRecipient,
      "offset": false
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', [_vm._v("Recipients")]), _vm.scheduleRows.length ? _c('div', {
          staticClass: "mx-3 btn-group btn-group-horizontal",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDelivery.add('Recipients');
            }
          }
        }, [_c('v-btn', {
          staticClass: "pl-3 pr-2",
          attrs: {
            "outlined": "",
            "rounded": "",
            "input-value": _vm.showAsTable
          },
          on: {
            "click": function ($event) {
              _vm.showAsTable = true;
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiTable)
          }
        })], 1), _c('v-btn', {
          staticClass: "pl-2 pr-3",
          attrs: {
            "outlined": "",
            "rounded": "",
            "input-value": !_vm.showAsTable
          },
          on: {
            "click": function ($event) {
              _vm.showAsTable = false;
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiCalendarMultiselect)
          }
        })], 1)], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 2393330585),
    model: {
      value: _vm.showDelivery,
      callback: function ($$v) {
        _vm.showDelivery = $$v;
      },
      expression: "showDelivery"
    }
  }, [_c('v-input', {
    attrs: {
      "rules": [function (v) {
        return !!v.length && !v.some(function (x) {
          return x.errors.length;
        });
      }],
      "value": _vm.scheduleRows
    }
  }), !_vm.scheduleRows.length ? _c('div', {
    staticClass: "mt-n5 pl-10"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.selectRow();
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right persistent"
  }, [_vm._v("Add recipient…")])], 1), _c('br'), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showImportSpreadsheet = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTableLarge)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right persistent"
  }, [_vm._v("Import from spreadsheet…")])], 1), _c('br'), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showImportContacts = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right persistent"
  }, [_vm._v("Import from Ellacard contacts…")])], 1)], 1) : _vm.showAsTable ? _c('div', {
    staticClass: "mt-n10 relative"
  }, [_c('div', {
    staticClass: "bulk-actions-container d-flex grey lighten-4 pr-sm-4 mr-sm-n4"
  }, [_c('div', {
    staticClass: "relative",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  }, [_c('btn-search', {
    staticClass: "absolute",
    staticStyle: {
      "right": "0"
    },
    attrs: {
      "tooltip": "Search recipients"
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref9) {
        var on = _ref9.on,
          attrs = _ref9.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiTableEdit)
          }
        }), _c('span', {
          staticClass: "btn-tooltip bottom left"
        }, [_vm._v("Bulk actions")])], 1)];
      }
    }], null, false, 3615331861)
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        return _vm.selectRow();
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  }), _c('div', [_vm._v("Add recipient…")])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        _vm.showImportSpreadsheet = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTableLarge)
    }
  }), _c('div', [_c('div', [_vm._v("Import from spreadsheet…")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("csv, xls, xlsx")])])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        _vm.showImportContacts = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
    }
  }), _c('div', [_vm._v("Import from Ellacard contacts…")])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": _vm.downloadRecipientsTable
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDownload)
    }
  }), _c('div', [_c('div', [_vm._v("Download")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("csv")])])], 1), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-list-item', {
    staticClass: "simple warning--text",
    on: {
      "click": function ($event) {
        _vm.$confirm({
          title: 'Are you sure?',
          msg: 'Are you sure you want to remove all the recipients of this automation?'
        }).then(function (r) {
          if (r == 'Yes') _vm.staged.rows = [];
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  }), _c('div', [_vm._v("Remove all recipients")])], 1)], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-2 automation-schedule-data-table row-pointer transparent",
    attrs: {
      "no-data-text": "No recipients",
      "must-sort": "",
      "sort-by": "next_create",
      "items-per-page": 50,
      "footer-props": {
        disableItemsPerPage: true,
        itemsPerPageOptions: [50]
      },
      "headers": _vm.headers,
      "items": _vm.scheduleRowsFiltered
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref10) {
        var item = _ref10.item,
          isMobile = _ref10.isMobile;
        return [_c('tr', {
          class: {
            'v-data-table__mobile-table-row': isMobile
          },
          on: {
            "click": function ($event) {
              return _vm.selectRow(item.data);
            }
          }
        }, _vm._l(_vm.headers.map(function (x) {
          var _x$value;
          return (_x$value = x.value) === null || _x$value === void 0 ? void 0 : _x$value.split('.').reduce(function (o, i) {
            return o[i];
          }, item);
        }), function (v, i) {
          return !isMobile || _vm.headers[i].text ? _c('td', {
            class: {
              'v-data-table__mobile-row': isMobile,
              'cell-error': !isMobile && _vm.headers[i].value && item.errors.includes(_vm.headers[i].value.slice(5))
            }
          }, [isMobile ? _c('th', {
            staticClass: "flex-grow-1 text--label-active text-left",
            class: {
              'error--text': isMobile && _vm.headers[i].value && item.errors.includes(_vm.headers[i].value.slice(5))
            },
            staticStyle: {
              "min-height": "21px"
            }
          }, [_vm._v(" " + _vm._s(_vm.headers[i].text) + " ")]) : _vm._e(), _vm.headers[i].value == 'next_create' ? [_vm._v(" " + _vm._s(_vm._f("moment")(item.next_create, 'short', item.data.timezone)) + " ")] : _vm.headers[i].value == 'data.recipient' ? [_vm._v(_vm._s(_vm._f("email-phone")(v)))] : _vm.headers[i].value == 'action' ? [_c('v-btn', {
            attrs: {
              "icon": "",
              "color": "primary"
            }
          }, [_c('v-icon', {
            domProps: {
              "innerHTML": _vm._s(_vm.mdiPencil)
            }
          })], 1)] : _c('div', {
            class: {
              'cell-contents-error': isMobile && _vm.headers[i].value && item.errors.includes(_vm.headers[i].value.slice(5))
            }
          }, [_vm._v(" " + _vm._s(v) + " ")])], 2) : _vm._e();
        }), 0)];
      }
    }], null, false, 236531593)
  })], 1) : _c('div', {
    staticClass: "mt-n4 mt-sm-n7"
  }, [_c('div', {
    staticClass: "mb-2 pl-4 pr-2 pr-sm-4 d-flex align-center"
  }, [_c('div', {
    staticClass: "d-flex my-n1"
  }, [_c('v-select', {
    staticClass: "white flex-shrink-0 mr-2",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": Object.keys(_vm.EN_MONTHS).map(function (x, i) {
        return {
          text: x.slice(0, 1).toUpperCase() + x.slice(1),
          value: i
        };
      }),
      "value": parseInt(_vm.calendarFocus.split('-')[1]) - 1
    },
    on: {
      "input": function (v) {
        var parts = _vm.calendarFocus.split('-');
        parts[1] = String(v + 1).padStart(2, '0');
        _vm.calendarFocus = parts.join('-');
      }
    }
  }), _c('v-select', {
    staticClass: "white flex-shrink-0",
    staticStyle: {
      "width": "108px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "items": _vm.eventYears,
      "value": _vm.calendarFocus.split('-')[0]
    },
    on: {
      "input": function (v) {
        var parts = _vm.calendarFocus.split('-');
        parts[0] = v;
        _vm.calendarFocus = parts.join('-');
      }
    }
  })], 1), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref11) {
        var on = _ref11.on,
          attrs = _ref11.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiTableEdit)
          }
        }), _c('span', {
          staticClass: "btn-tooltip bottom left"
        }, [_vm._v("Bulk actions")])], 1)];
      }
    }], null, false, 3615331861)
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        return _vm.selectRow();
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  }), _c('div', [_vm._v("Add recipient…")])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        _vm.showImportSpreadsheet = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTableLarge)
    }
  }), _c('div', [_c('div', [_vm._v("Import from spreadsheet…")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("csv, xls, xlsx")])])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": function ($event) {
        _vm.showImportContacts = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardAccountPhone)
    }
  }), _c('div', [_vm._v("Import from Ellacard contacts…")])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "click": _vm.downloadRecipientsTable
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDownload)
    }
  }), _c('div', [_c('div', [_vm._v("Download")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("csv")])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "overflow-hidden"
  }, [_c('v-sheet', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "height": 680
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    staticClass: "calendar-automation",
    attrs: {
      "event-more": "",
      "event-ripple": "",
      "event-color": "transparent",
      "events": _vm.events
    },
    scopedSlots: _vm._u([{
      key: "event",
      fn: function (_ref12) {
        var _event$errors;
        var event = _ref12.event;
        return [event.orderId ? _c('v-menu', {
          attrs: {
            "bottom": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref13) {
              var on = _ref13.on,
                attrs = _ref13.attrs;
              return [_c('v-card', _vm._g(_vm._b({
                staticClass: "px-1 d-flex align-center",
                attrs: {
                  "color": "primary",
                  "dark": "",
                  "hover": ""
                }
              }, 'v-card', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "x-small": "",
                  "color": "white"
                },
                domProps: {
                  "innerHTML": _vm._s(_vm.mdiHistory)
                }
              }), _c('div', {
                staticClass: "mx-1 flex-grow-1",
                staticStyle: {
                  "white-space": "nowrap",
                  "overflow": "hidden",
                  "text-overflow": "ellipsis"
                }
              }, [_vm._v(" " + _vm._s(_vm._f("email-phone")(_vm.customFields.includes('name') && event.row.name || event.row.recipient || '–')) + " ")]), _c('v-icon', {
                staticClass: "menu-down",
                attrs: {
                  "small": "",
                  "color": "white"
                },
                domProps: {
                  "innerHTML": _vm._s(_vm.mdiMenuDown)
                }
              })], 1)];
            }
          }], null, true)
        }, [_c('v-list', {
          staticClass: "primary--text text-body-2",
          attrs: {
            "dense": ""
          }
        }, [_c('div', {
          staticClass: "text--label-active px-3 mb-1"
        }, [_vm._v("This order has already been created")]), _c('v-list-item', {
          staticClass: "simple",
          attrs: {
            "target": "_blank",
            "to": {
              name: 'account-orders',
              params: {
                orderId: event.orderId
              }
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiOpenInNew)
          }
        }), _c('div', [_vm._v("Open existing order…")])], 1), _c('v-list-item', {
          staticClass: "simple",
          on: {
            "click": function () {
              var recipient = event.row.recipient.toLowerCase();
              var row = _vm.staged.rows.find(function (x) {
                var _x$recipient;
                return ((_x$recipient = x.recipient) === null || _x$recipient === void 0 ? void 0 : _x$recipient.toLowerCase()) == recipient;
              });
              if (row) _vm.selectRow(row);else _vm.$confirm({
                title: 'Recipient not found',
                msg: 'This recipient was not found in your automation (the recipient was likely removed / updated after this order was created).<br><br>Would you like to add this recipient back to your automation?',
                buttons: ['Cancel', 'Add'],
                primary: 'Add'
              }).then(function (r) {
                return r == 'Add' && _vm.selectRow(event.row);
              });
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPencil)
          }
        }), _c('div', [_vm._v("Edit automation recipient…")])], 1)], 1)], 1) : _c('v-card', {
          staticClass: "px-1 future-event",
          class: {
            'future-event-error': (_event$errors = event.errors) === null || _event$errors === void 0 ? void 0 : _event$errors.length
          },
          staticStyle: {
            "white-space": "nowrap",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          },
          attrs: {
            "color": "white",
            "hover": "",
            "outlined": ""
          },
          on: {
            "click": function ($event) {
              return _vm.selectRow(event.row);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("email-phone")(_vm.customFields.includes('name') && event.row.name || event.row.recipient || '–')) + " ")])];
      }
    }], null, false, 2713989370),
    model: {
      value: _vm.calendarFocus,
      callback: function ($$v) {
        _vm.calendarFocus = $$v;
      },
      expression: "calendarFocus"
    }
  })], 1)], 1)])], 1), _c('title-toggle', {
    ref: "delivery:options",
    attrs: {
      "title": "Delivery options",
      "icon": _vm.mdiCog
    },
    model: {
      value: _vm.showDelivery,
      callback: function ($$v) {
        _vm.showDelivery = $$v;
      },
      expression: "showDelivery"
    }
  }, [!((_vm$orgSkin = _vm.orgSkin) !== null && _vm$orgSkin !== void 0 && _vm$orgSkin.email_subject) ? _c('v-text-field', {
    staticClass: "white inline-error",
    attrs: {
      "dense": "",
      "outlined": "",
      "persistent-placeholder": "",
      "label": "Customize the subject line",
      "rules": [function (v) {
        return /\S/.test(v || '') || 'Required';
      }, function (v) {
        return (v || '').length <= 100 || `Too long (${v.length} / 100)`;
      }]
    },
    model: {
      value: _vm.staged.order.skin.email_subject,
      callback: function ($$v) {
        _vm.$set(_vm.staged.order.skin, "email_subject", $$v);
      },
      expression: "staged.order.skin.email_subject"
    }
  }) : _vm._e(), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Allow recipients to respond to your card",
      "input-value": !_vm.staged.order.skin.disable_reply
    },
    on: {
      "change": function (v) {
        return _vm.staged.order.skin.disable_reply = !v;
      }
    }
  }), _vm.staged.order.type == 'GROUP' ? _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v("Any group signing contributors who provided their email address when signing the card will also see responses")]) : _vm._e()], 1)], 1) : _vm.$route.hash == '#payment' ? _c('div', [_c('title-toggle', {
    ref: "payment:placing",
    attrs: {
      "title": "Placing orders",
      "icon": _vm.mdiCartArrowRight
    },
    model: {
      value: _vm.showPayment,
      callback: function ($$v) {
        _vm.showPayment = $$v;
      },
      expression: "showPayment"
    }
  }, [_c('div', {
    staticClass: "mb-1 text--label-active"
  }, [_vm._v(" Create orders this many days in advance of the scheduled send date ")]), _c('int-field', {
    attrs: {
      "required": "",
      "min": _vm.staged.order.type == 'GROUP' ? 1 : 0,
      "max": 14
    },
    model: {
      value: _vm.staged.n_days_in_advance,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "n_days_in_advance", $$v);
      },
      expression: "staged.n_days_in_advance"
    }
  }), _vm.staged.order.type == 'GROUP' && !_vm.staged.n_days_in_advance ? _c('div', {
    staticClass: "mt-1 text--label-active error--text"
  }, [_vm._v("Group cards must be scheduled in advance to give others a chance to sign")]) : _vm._e(), _c('v-checkbox', {
    staticClass: "mt-9",
    attrs: {
      "hide-details": "",
      "label": "Send order confirmation emails"
    },
    model: {
      value: _vm.staged.send_confirmation,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "send_confirmation", $$v);
      },
      expression: "staged.send_confirmation"
    }
  }), _c('div', {
    staticClass: "ml-8 mb-9 text--label-active"
  }, [_vm._v(" Send yourself (or the delegated owner) a confirmation email every time an order gets placed ")])], 1), _c('title-toggle', {
    ref: "payment:payment",
    attrs: {
      "title": "Payment",
      "loading": _vm.loadPriceStatus.pending,
      "icon": _vm.mdiCurrencyUsd
    },
    model: {
      value: _vm.showPayment,
      callback: function ($$v) {
        _vm.showPayment = $$v;
      },
      expression: "showPayment"
    }
  }, [_c('div', [_vm.isSignedIn ? [_vm.isCovered ? _c('div', {
    staticClass: "d-flex align-start"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "success"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCheckCircle)
    }
  }), _c('div', [_vm._v("The projected annual cost of this automation is covered by your current subscription / credits")])], 1) : _c('div', {
    staticClass: "d-flex align-start"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMinusCircle)
    }
  }), _c('div', [_c('div', [_vm._v("The projected annual cost of this automation is not covered by your current subscription / credits")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Additional balance required: $" + _vm._s((_vm$itemized = _vm.itemized) === null || _vm$itemized === void 0 ? void 0 : _vm$itemized.price))])])], 1), _c('div', {
    staticClass: "py-1",
    staticStyle: {
      "margin": "0 -16px 0 -48px"
    }
  }, [_c('v-list-item', {
    staticClass: "simple primary--text",
    staticStyle: {
      "padding": "12px 16px 12px 48px"
    },
    attrs: {
      "aria-expanded": String(_vm.showItemized),
      "disabled": !_vm.itemized
    },
    on: {
      "click": function ($event) {
        _vm.showItemized = !_vm.showItemized;
      }
    }
  }, [_c('v-icon', {
    staticClass: "menu-down",
    staticStyle: {
      "margin-right": "0 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMenuDown)
    }
  }), _c('div', [_vm._v("Projected annual cost breakdown")])], 1)], 1), _c('v-expand-transition', [_vm.itemized && _vm.showItemized ? _c('div', {
    staticClass: "pl-8",
    staticStyle: {
      "width": "432px",
      "max-width": "100%"
    }
  }, [_c('itemized-price', {
    staticStyle: {
      "text-transform": "none !important",
      "text-align": "left"
    },
    attrs: {
      "itemized": _vm.itemized
    }
  })], 1) : _vm._e()])] : _c('div', [_c('v-btn', {
    staticStyle: {
      "margin": "-6px 0 -6px -16px",
      "text-transform": "none",
      "letter-spacing": "normal",
      "font-size": "1em"
    },
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.promptSignIn
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccount)
    }
  }), _vm._v(" Sign in "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v(" Sign in to set up payment for this automation ")])], 1), _c('div', {
    staticClass: "mt-9"
  }, [_c('v-btn', {
    staticStyle: {
      "margin": "-6px 0 -6px -16px",
      "text-transform": "none",
      "letter-spacing": "normal",
      "font-size": "1em"
    },
    attrs: {
      "text": "",
      "color": "primary",
      "to": {
        name: 'pricing',
        hash: '#subscriptions'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendarSync)
    }
  }), _vm._v(" Add / upgrade subscription "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v(" Current subscription plan: "), _vm.subscriptionStatus == 'ACTIVE' ? [_vm._v(_vm._s(_vm.account.subscription.metadata.code) + " (renews " + _vm._s(_vm._f("moment")(_vm.account.subscription.next_at, 'short-date')) + ")")] : _vm.subscriptionStatus == 'ACTIVE_CANCELLED' ? [_vm._v(_vm._s(_vm.account.subscription.metadata.code) + " (expires " + _vm._s(_vm._f("moment")(_vm.account.subscription.next_at, 'short-date')) + ")")] : [_vm._v("–")]], 2)], 1), _c('div', {
    staticClass: "mt-9"
  }, [_c('v-btn', {
    staticStyle: {
      "margin": "-6px 0 -6px -16px",
      "text-transform": "none",
      "letter-spacing": "normal",
      "font-size": "1em"
    },
    attrs: {
      "text": "",
      "color": "primary",
      "to": {
        name: 'pricing',
        hash: '#pre-paid-credit'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCurrencyUsd)
    }
  }), _vm._v(" Pre-pay for discounted credit "), _c('v-icon', {
    staticClass: "ml-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v("Current credit: "), (_vm$account = _vm.account) !== null && _vm$account !== void 0 && _vm$account.credit_money && _vm.account.credit_money != '0.00' ? [_vm._v("$" + _vm._s(_vm.account.credit_money))] : [_vm._v("–")]], 2), (_vm$account2 = _vm.account) !== null && _vm$account2 !== void 0 && _vm$account2.giftcard_credit ? _c('div', {
    staticClass: "pl-8 text--label-active"
  }, [_vm._v("Current gift card credit: $" + _vm._s(_vm.account.giftcard_credit))]) : _vm._e()], 1), _c('v-checkbox', {
    staticClass: "mt-9",
    attrs: {
      "hide-details": "",
      "label": "Automatically charge saved payment method",
      "rules": [function (v) {
        return !v || !!_vm.paymentMethod;
      }]
    },
    model: {
      value: _vm.staged.auto_pay,
      callback: function ($$v) {
        _vm.$set(_vm.staged, "auto_pay", $$v);
      },
      expression: "staged.auto_pay"
    }
  }), _c('div', {
    staticClass: "ml-8 text--label-active"
  }, [_vm._v("When placing an order, we'll first try to use any subscription discounts or saved credits. If your balance is exceeded, we can either pause the automation (and notify you) or automatically charge your saved payment method.")]), _vm.staged.auto_pay ? _c('div', {
    staticClass: "mt-3 pl-8"
  }, [_vm.paymentMethod ? _c('div', {
    staticClass: "d-inline-flex align-center"
  }, [_c('credit-card-preview', {
    attrs: {
      "card": _vm.paymentMethod.card
    }
  }), _c('div', {
    staticClass: "ml-2 mr-3 text--label-active"
  }, [_vm._v(_vm._s(_vm.paymentMethod.description))]), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "to": {
        name: 'account-overview'
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right"
  }, [_vm._v("Manage saved payment methods")])], 1)], 1) : _c('v-btn', {
    staticClass: "ml-n2",
    attrs: {
      "icon": "",
      "color": "error"
    },
    on: {
      "click": function () {
        if (_vm.isSignedIn) _vm.showAddPaymentMethod = true;else _vm.promptSignIn();
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCreditCardPlus)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right persistent"
  }, [_vm._v("Add payment method")])], 1)], 1) : _vm._e()], 2)])], 1) : _vm._e()], 1) : _vm._e()], 1), _c('div', {
    staticClass: "flex-grow-0 pa-3 elevation-6 overflow-visible d-flex justify-end",
    staticStyle: {
      "z-index": "2"
    }
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.$route.hash,
      expression: "!!$route.hash"
    }],
    staticClass: "pl-2",
    attrs: {
      "exact": "",
      "text": "",
      "color": "ec-dark-blue",
      "to": _vm.$routeAssign({
        hash: undefined
      })
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" Automation ")], 1) : _c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "exact": "",
      "text": "",
      "color": "ec-dark-blue",
      "to": _vm.back ? _vm.$routeAssign({
        hash: '#' + _vm.back
      }) : _vm.routeOnClose
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" Back ")], 1), _c('v-spacer'), _c('v-btn', {
    class: {
      pulse: _vm.isDirty
    },
    attrs: {
      "text": "",
      "color": "ec-dark-blue",
      "disabled": !_vm.isDirty,
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" Save ")]), _vm.$route.hash ? _c('v-btn', {
    staticClass: "pr-2",
    attrs: {
      "exact": "",
      "text": "",
      "color": "ec-dark-blue",
      "disabled": _vm.loadStatus.pending,
      "loading": _vm.loadStatus.pending,
      "to": _vm.$routeAssign({
        hash: _vm.next ? '#' + _vm.next : undefined
      })
    }
  }, [_vm._v(" Next "), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1) : _vm._e()], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }